import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseByMonthDatatable";

import {
  getSingleMonthlyExpenseRedux,
  getSingleMonthlyCashInRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import "./monthlyexpenseByMonth.css";
import "./monthlyexpense.css";
import logo from "./cloudshopBD.png";
export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
      filterCategoryCashIn: "",
      filterCategoryCashOut: "",
    };
  }

  componentDidMount = async () => {
    const [type, month] = this.props.match.params.month.split("-");
    if (type === "expense") {
      this.props.getSingleMonthlyExpenseRedux(month);
    } else {
      this.props.getSingleMonthlyCashInRedux(month);
    }
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { open } = this.state;
    const [type, month] = this.props.match.params.month.split("-");
    console.log(this.props);
    let totalCashIns = 0;
    let totalCashOuts = 0;
    let renderableExpense = this.props.allExpenses;
    if (this.state.filterCategoryCashOut) {
      renderableExpense = this.props.allExpenses.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashOut.toLowerCase()
      );
    }
    renderableExpense.map((expense) => {
      totalCashOuts += parseInt(expense.amount);
    });

    let renderableCashIn = this.props.allCashIns;
    if (this.state.filterCategoryCashIn) {
      renderableCashIn = this.props.allCashIns.filter(
        (expense) =>
          expense.category &&
          expense.category.toLowerCase() ==
            this.state.filterCategoryCashIn.toLowerCase()
      );
    }
    renderableCashIn.map((cashIn) => {
      totalCashIns += parseInt(cashIn.amount);
    });

    let data = [];
    if (type === "expense") {
      data = renderableExpense;
    } else {
      data = renderableCashIn;
    }

    return (
      <Fragment>
        <Breadcrumb
          title={type === "expense" ? "Cash Out" : "Cash In"}
          parent="expense history"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid mh-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mh-card">
                <div
                  className="card-header mh-card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 10,
                  }}
                >
                  <h5 className="mh-card-title">
                    <i className="icofont-calendar mh-card-icon"></i>
                    {month}
                  </h5>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <ReactToPrint
                      trigger={() => (
                        <button className="btn mh-print-btn">
                          Monthly Statement
                        </button>
                      )}
                      content={() => this.componentRef}
                    />

                    {type === "expense" ? (
                      <select
                        title="Filter by category"
                        required
                        name="filterCategoryCashOut"
                        className="custom-select mh-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCategoryCashOut}
                      >
                        <option value="">Filter by category </option>
                        <option value="">All</option>
                        <option value="DAILY COST">DAILY COST</option>
                        <option value="OFFICE">OFFICE</option>
                        <option value="SALARY">SALARY</option>
                        <option value="LOAN">LOAN</option>
                        <option value="SHIPPING">SHIPPING</option>
                        <option value="Boosting">BOOSTING/PROMOTION</option>
                        <option value="REFUND">REFUND</option>
                        <option value="TRANSPORT">TRANSPORT</option>
                        <option value="BUY PRODUCTS">BUY PRODUCTS</option>
                      </select>
                    ) : (
                      <select
                        title="Filter by category"
                        required
                        name="filterCategoryCashIn"
                        className="custom-select mh-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.filterCategoryCashIn}
                      >
                        <option value="">Filter by category </option>
                        <option value="">All </option>
                        <option value="LOAN">LOAN</option>
                        <option value="OTHERS">OTHERS</option>
                        <option value="ORDERS">ORDERS</option>
                      </select>
                    )}
                  </div>
                </div>
                <div className="card-body">
                  <div className="mh-total-chip">
                    <span className="mh-total-chip-label mh-stamp-font">
                      {type === "expense" ? "Cash Out Total" : "Cash In Total"}
                    </span>
                    <span className="mh-total-chip-value">
                      {type == "expense" ? totalCashOuts : totalCashIns}Tk
                    </span>
                  </div>
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <div className="print-table-wrapper">
                      <Datatable
                        startToggleModal={this.startToggleModal}
                        history={this.props.history}
                        multiSelectOption={false}
                        myData={
                          type === "expense"
                            ? renderableExpense
                            : renderableCashIn
                        }
                        pageSize={50}
                        pagination={true}
                        class="-striped -highlight"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
        <div style={{ display: "none" }}>
          <div ref={(el) => (this.componentRef = el)} className="print-area">
            <div>
              <img
                className="blur-up lazyloaded"
                src={logo}
                alt=""
                style={{ maxWidth: "20%" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div style={{ fontWeight: "bold" }}>
                  44/45, 5th floor,Bikrampur Housing,
                </div>
                <div style={{ fontWeight: "bold" }}>
                  New Alibohar,Postogola,Dhaka-1204
                </div>
                <div style={{ fontWeight: "bold" }}>zapaibd@gmail.com</div>
                <div style={{ fontWeight: "bold" }}>
                  📞 ফোন: 01560002099 / 01400045207
                </div>
              </div>

              <div>
                <div style={{ fontWeight: "bold", fontSize: 17 }}>
                  Monthly Statement
                </div>
                <div style={{ fontWeight: "bold" }}>
                  Created At:{new Date().toLocaleDateString()} at{" "}
                  {new Date().toLocaleTimeString()}
                </div>
                <div style={{ fontWeight: "bold" }}> {month}</div>
                <div style={{ fontWeight: "bold" }}> </div>
                <div style={{ color: "black", fontWeight: "bold" }}>
                  {type === "expense" ? "Cash Out" : "Cash In"} Total:
                  {type == "expense" ? totalCashOuts : totalCashIns}Tk
                </div>
              </div>
            </div>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "20px",
              }}
            >
              <thead>
                <tr style={{ background: "#e7e7e7" }}>
                  <th
                    style={{
                      border: "1px solid gainsboro",
                      padding: "20px 8px",
                      textAlign: "left",
                      paddingLeft: 10,
                      fontWeight: "bold",
                    }}
                  >
                    #
                  </th>
                  <th
                    style={{
                      border: "1px solid gainsboro",
                      padding: "20px 8px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    Date
                  </th>
                  <th
                    style={{
                      border: "1px solid gainsboro",
                      padding: "20px 8px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    Category
                  </th>
                  <th
                    style={{
                      border: "1px solid gainsboro",
                      padding: "20px 8px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    Sub Category
                  </th>
                  <th
                    style={{
                      border: "1px solid gainsboro",
                      padding: "20px 8px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    Note
                  </th>
                  <th
                    style={{
                      border: "1px solid gainsboro",
                      padding: "20px 8px",
                      textAlign: "right",
                      paddingRight: 10,
                      fontWeight: "bold",
                    }}
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        border: "1px solid gainsboro",
                        padding: "8px",
                        textAlign: "left",
                        paddingLeft: 10,
                      }}
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        border: "1px solid gainsboro",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {item.date}
                    </td>
                    <td
                      style={{
                        border: "1px solid gainsboro",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {item.category}
                    </td>
                    <td
                      style={{
                        border: "1px solid gainsboro",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {String(item.subCategory || "").replace(/^undefined-/, "")}
                    </td>
                    <td
                      style={{
                        border: "1px solid gainsboro",
                        padding: "8px",
                        textAlign: "left",
                      }}
                    >
                      {item.note}
                    </td>
                    <td
                      style={{
                        border: "1px solid gainsboro",
                        padding: "8px",
                        textAlign: "right",
                        paddingRight: 10,
                      }}
                    >
                      {item.amount}Tk
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.expenses.singleMonthExpense,
    allCashIns: state.cashIns.singleMonthCashIn,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyExpenseRedux,
  getSingleMonthlyCashInRedux,
})(MonthlyExpenseByMonth);
